import React from 'react'
import { Icon } from '@insight/toolkit-react'
import CalloutActions from '../SearchProducts/CalloutAction'
import { IPS_MAIN_SEARCH_BANNER } from '../../constants'
import { connectToLocale } from '@insight/toolkit-react'

const IPSLogoutBanner = ({ context }) => {
    const { isLoggedIn, isIPSUser } = context
    const  isLogoutIPSUser = !isLoggedIn && isIPSUser;

    if (!isLogoutIPSUser) return null

    return (
        <div className="c-ips-logout-banner">
            <div className="o-grid o-grid--center o-grid--justify-between">
                <div className="o-grid__item u-1/1 u-2/3@tablet-landscape c-ips-logout-banner__content">
                    <div className="c-ips-logout-banner__icon">
                        <Icon
                            color="primary"
                            icon="contract-pricing"
                            title="info"
                            type="info"
                        />
                    </div>
                   
                    <div className="c-ips-logout-banner__header">
                        <h3>Get Contract Pricing and Build Quotes</h3>
                    </div>
                    <div className="c-ips-logout-banner__text">
                        <p>
                            Log in or create an account to see available contracts with better pricing and access quote-building tools.
                        </p>
                    </div>
                </div>
                <div className="o-grid__item u-1/1 u-1/3@tablet-landscape c-ips-logout-banner__actions">
                    <CalloutActions
                        isLoggedOutIPS={true}
                        categoryType={IPS_MAIN_SEARCH_BANNER}
                    />
                </div>
            </div>
        </div>
    )
}

export default connectToLocale(IPSLogoutBanner)